export default function initReadMore() {

  //This script only applies to elements with the BS collapse with a "READ MORE" label
  //NOTE: The uppercase "READ MORE" is handled via CSS

  var buttons = document.querySelectorAll('button[data-bs-toggle="collapse"]');

  // Quick check to see if any button is worth processing
  // Exit if no buttons with "READ MORE" are found

  if (!Array.from(buttons).some(button => button.querySelector('.btn-label')?.textContent.trim() === 'Read More')) {
    return;
  }

  buttons.forEach(function (button) {
    var targetId = button.getAttribute('data-bs-target');
    var label = button.querySelector('.btn-label');

    if (label && label.textContent.trim() === 'Read More') {
      targetId = targetId.startsWith('#') ? targetId : '#' + targetId;
      var collapseElement = document.querySelector(targetId);

      if (collapseElement) {
        collapseElement.addEventListener('show.bs.collapse', function () {
          label.textContent = 'Read Less';
        });

        collapseElement.addEventListener('hide.bs.collapse', function () {
          label.textContent = 'Read More';
        });
      }
    }
  });

}
